import type { YammerState } from '@ms/yammer-data/dist/state/types';
import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector as useUntypedSelector } from 'react-redux';

export const useSelector: TypedUseSelectorHook<YammerState> = useUntypedSelector;
